// src/context/AuthContext.jsx
import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [userTipo, setUserTipo] = useState(localStorage.getItem('tipo') || '');
  const [username, setUsername] = useState(localStorage.getItem('user') || '');
  const [podeUsarKitBlindagem, setPodeUsarKitBlindagem] = useState(localStorage.getItem('pode_usar_kit_blindagem') === '1');

  useEffect(() => {
    localStorage.setItem('tipo', userTipo);
  }, [userTipo]);

  useEffect(() => {
    localStorage.setItem('user', username);
  }, [username]);

  useEffect(() => {
    localStorage.setItem('pode_usar_kit_blindagem', podeUsarKitBlindagem ? '1' : '0');
  }, [podeUsarKitBlindagem]);

  return (
    <AuthContext.Provider
      value={{
        userTipo,
        setUserTipo,
        username,
        setUsername,
        podeUsarKitBlindagem,
        setPodeUsarKitBlindagem,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
